import { SCENARIOS } from "../data";
import SectionHeader from "./SectionHeader";
import { useSectionTrack } from "../hooks/useSectionTrack";

const hexToRgb = (hex) => {
  const m = hex.replace("#", "");
  return [0, 2, 4].map((i) => parseInt(m.slice(i, i + 2), 16)).join(",");
};

function ScenarioCard({ s, i }) {
  const rgb = hexToRgb(s.hue);
  const pct = Math.min(100, Math.round((s.going / s.cap) * 100));

  const stripe   = { background: `linear-gradient(90deg, ${s.hue}, rgba(${rgb},.3))` };
  const whenPill = {
    color:      s.hue,
    background: `rgba(${rgb},.14)`,
    border:     `1px solid rgba(${rgb},.30)`,
  };
  const dotGlow  = { background: s.hue, boxShadow: `0 0 6px ${s.hue}` };
  const fill     = { width: `${pct}%`, background: `linear-gradient(90deg, ${s.hue}, rgba(${rgb},.6))` };
  const cta      = {
    background: `linear-gradient(135deg, ${s.hue}, rgba(${rgb},.7))`,
    boxShadow:  `0 6px 16px rgba(${rgb},.35)`,
  };

  return (
    <div className={`glass card-lift-white scenario section-enter section-enter-delay-${i + 1}`}>
      <div className="scenario-stripe" style={stripe} />

      <div className="scenario-head">
        <span className="scenario-when" style={whenPill}>
          <span className="scenario-dot" style={dotGlow} />
          {s.when}
        </span>
        <span className="scenario-cap">{s.going}/{s.cap}</span>
      </div>

      <div className="scenario-title">{s.title}</div>
      <div className="scenario-place">{s.place}</div>
      <p className="scenario-body">{s.body}</p>

      <div className="scenario-bar">
        <div className="scenario-bar-fill" style={fill} />
      </div>

      <a
        href="#download"
        className="scenario-cta"
        style={cta}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-2px)";
          e.currentTarget.style.boxShadow = `0 10px 24px rgba(${rgb},.45)`;
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "none";
          e.currentTarget.style.boxShadow = `0 6px 16px rgba(${rgb},.35)`;
        }}
      >
        Иду →
      </a>
    </div>
  );
}

export default function Reviews() {
  const ref = useSectionTrack("scenarios");

  return (
    <section ref={ref} id="scenarios" className="sec" style={{ background: "transparent" }}>
      <SectionHeader
        label="А что внутри?"
        title="Вот примеры событий — как они выглядят в приложении"
        maxWidth={620}
      />
      <div className="grid-3">
        {SCENARIOS.map((s, i) => (
          <ScenarioCard key={s.title} s={s} i={i} />
        ))}
      </div>
      <p className="section-footnote">Примеры. Реальные события — внутри приложения.</p>
    </section>
  );
}
